/**!
 * Created by Leonardo Cheslacki on 30/04/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import GamesController from './GamesController';

import WithType from './../helpers/WithType';

let _this = {};

const {default: {routes: {api, web}}, memory: {pseudos}} = require('./../../../../config');

/**
 *
 */
class GamesMemory extends GamesController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            activities: [],
            tracks: [],
            life: null,
            time_out: null,
            checked: [],
            count: 0,
            answers: {}
        };

        this.$current_frame = 1;

        this.$count = null;

        _this = this;
    };

    $functions = {
        handleButtonStart: function () {
            _this.$current_frame++;

            const
                _this_current = _this.get(),
                {occ_count_down} = _this_current;

            /**
             *
             *  Stop the movie clip in frame.
             */
            _this.gotoAndStopFrame(_this_current, _this.$current_frame);

            _this.quizzesActivity();

            _this.count(() => {
                _this.throttle('set-answers', () => {
                    const {occ_content_memory} = _this.getFrame();
                    occ_count_down.visible = false;
                    occ_content_memory.visible = false;
                    _this.setAnswers(4, _this.$functions.handleButtonFinish)();
                });
            });
        },

        handleButtonFinish: function () {
            const
                {disabled} = _this.state,
                {parent_id} = _this.props;

            !Boolean(disabled) && _this.main.redirectRoute(`${_this.$root_uri}/${web.uri_activity_levels}/${parent_id}`);
        },

        /**
         *
         * @param event
         * @param btn_answer
         * @param answer
         * @param activity_id
         */
        handleButtonAnswer: function (event, {btn_answer, answer, activity_id}) {
            const
                {checked} = _this.state,
                {data_frames} = _this.props,
                {clicked} = btn_answer.state,
                _this_current = _this.get(),
                length = _this.lengthObject(answer);

            let
                i = 0,
                check = false;

            if (!Boolean(clicked) && checked.length < 2) {
                _this.switchButton(btn_answer, true);

                !_this.inArray(checked, btn_answer) && checked.push(btn_answer);

                _this.setState({..._this.state, checked: checked});

                if (checked.length === 2) {
                    for (let property in answer) {
                        i++;

                        if (_this.inArray(answer[property], checked[0].state._id) && _this.inArray(answer[property], checked[1].state._id)) {
                            check = true;
                            _this.state.count++;
                            _this.setStates({answers: {[activity_id]: [answer[property]]}});
                            _this.disableTitle(property);
                        }

                        if (length < (i + 1)) {
                            if (!check) {
                                _this.throttle('handle-button-answer', () => {
                                    for (let i = 0; checked.length > i; i++) {
                                        _this.switchButton(checked[i], false);
                                        _this.endFor(checked.length, i) && _this.setState({
                                            ..._this.state,
                                            checked: []
                                        });
                                    }
                                }, 2000);
                            } else {
                                _this.setState({..._this.state, checked: []});
                            }
                        }
                    }
                }
            } else {
                return _this.stopPropagation(event);
            }

            if (_this.state.count >= length) {
                if (_this.$current_frame <= data_frames.length) {
                    _this.$count.pause();
                    _this.throttle('set-answers', _this.setAnswers(3, () => {
                        _this.$current_frame++;
                        _this.gotoAndStopFrame(_this_current, _this.$current_frame);
                        _this.resetAnswers();
                        _this.quizzesActivity();
                        _this.$count.resume();
                    }));
                } else {
                    _this.throttle('set-answers', () => {
                        _this.clearCountDownMoment('count-memory');
                        _this.gotoAndStopFrame(_this_current, _this_current.totalFrames - 1);
                        _this.readAudioSay(_this.findTack('finish_out'));
                        this._handleButtonFinish && _this_current.btn_finish.off('mousedown', this._handleButtonFinish);
                        this._handleButtonFinish = _this_current.btn_finish.on('mousedown', _this.$functions.handleButtonFinish);
                    });
                }
            }
        }
    };

    /**
     *
     * @param btn_answer
     * @param sprite
     * @param color
     */
    setButtonTemplate = (btn_answer, sprite, color) => {
        for (let i = 0; i < pseudos.length; i++) {
            if (this.inArray(['effect', 'hover'], pseudos[i])) {

                let pseudo = this.getPseudo(btn_answer, pseudos[i]);

                for (let property of pseudo.occ_animate_face.children) {
                    property.visible = (this.toNumber(property.name) === this.toNumber(sprite));
                }

                for (let property of pseudo.occ_animate_color.children) {
                    property.visible = property.name.includes(color);
                }

                pseudo.occ_animate_face.visible = false;
                pseudo.occ_animate_color.visible = true;
            }
        }
    };

    /**
     *
     * @param btn_answer
     * @param clicked
     */
    switchButton = (btn_answer, clicked) => {
        const
            {occ_pseudo_hover, occ_pseudo_effect} = btn_answer,
            {_id} = btn_answer.state;

        if (clicked) {
            this.setStateOccurrence(btn_answer, {clicked: true});
            occ_pseudo_effect.occ_animate_face.visible = true;
            occ_pseudo_hover.occ_animate_color.visible = false;
            occ_pseudo_effect.gotoAndPlay('start');
        } else {
            occ_pseudo_effect.gotoAndPlay('end');
            this.throttle(`switch-button-${_id}`, () => {
                occ_pseudo_hover.occ_animate_color.visible = true;
                occ_pseudo_effect.occ_animate_face.visible = false;
                this.setStateOccurrence(btn_answer, {clicked: false});
            }, 500);
        }
    };

    quizzesActivity = () => {
        const
            _this_frame = this.getFrame(),
            data_frame = this.findDataFrame(this.$current_frame),
            {sprites, color} = data_frame,
            activity = this.findActivity(this.$current_frame),
            {template: {answer, activity_id}} = activity;

        let
            sprites_copy = [...sprites],
            answer_copy = {...answer},
            formatted_say_uri = this.verifyField(activity, 'formatted_say_uri');

        formatted_say_uri && this.readAudioSay(activity);

        this.getGrid(data_frame, (row, col) => {
            let
                occ_part = _this_frame.occ_part.clone(),
                {btn_answer} = occ_part,
                {
                    width,
                    height
                } = btn_answer.occ_pseudo_effect.occ_animate_color.nominalBounds,
                sprite = this.randomArrayNoRepeat(sprites_copy);

            this.setButtonTemplate(btn_answer, sprite, color);

            occ_part.x = (width * col) + (col * 10);
            occ_part.y = (height * row) + (row * 10);

            _this_frame.occ_content_memory.addChild(occ_part);

            this.setStateOccurrence(btn_answer, {_id: sprite, clicked: false});

            this[`_handleButtonAnswer${row}${col}`] && btn_answer.off('mousedown', this[`_handleButtonAnswer${row}${col}`]);
            this[`_handleButtonAnswer${row}${col}`] = btn_answer.on('mousedown', this.$functions.handleButtonAnswer, false, false, {
                btn_answer: btn_answer,
                answer: answer_copy,
                activity_id: activity_id
            });
        });
    };

    resetAnswers = () => {
        const
            {occ_response} = this.get(),
            _this_frame = this.getFrame(occ_response);

        this.setState({...this.state, checked: [], count: 0}, () => {
            /**
             * Reset for frame01 in layer null.
             */
            this.gotoAndStopFrame(occ_response, 1);
            this.gotoAndStopFrame(_this_frame, 1);
        });
    };

    count = (callback) => {
        const
            {delay_sequence} = this.props,
            {time_out} = this.state,
            {occ_count_down} = this.get();

        this.$count = this.countDownMoment('count-memory', delay_sequence, time_out, (time) => {
            occ_count_down.text = time;
        }, () => {
            (typeof (callback) === 'function') && callback(true);
        });
    };

    startMemory = () => {
        const
            _this_current = this.get(),
            {time_out} = this.state,
            {btn_start, btn_out, occ_count_down} = _this_current;

        /**
         * Set initial time.
         * @type {string}
         */
        occ_count_down.text = this.getFormatMinutes(time_out);

        this._handleButtonStart && btn_start.off('mousedown', this._handleButtonStart);
        this._handleButtonStart = btn_start.on('mousedown', this.$functions.handleButtonStart);

        this._handleButtonOut && btn_out.off('mousedown', this._handleButtonOut);
        this._handleButtonOut = btn_out.on('mousedown', this.$functions.handleButtonFinish);
    };

    initMemory = () => {
        const {quiz_id} = this.props;

        this.gotoAndStopFrame(this.get(), this.$current_frame);

        this.main.getForm(`${this.$root_uri}/${api.api_activity_template}/${quiz_id}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({
                        ...this.state,
                        activities: this.verifyField(data, 'quiz.activities'),
                        tracks: this.verifyField(data, 'tracks'),
                        life: this.verifyField(data, 'quiz.life'),
                        time_out: this.verifyField(data, 'quiz.time')
                    }, this.startMemory);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };
}

/**
 *
 * @type {{}}
 */
GamesMemory.propTypes = {
    current_name: PropTypes.string,
    data_frames: PropTypes.array,
    parent_id: PropTypes.number,
    quiz_id: PropTypes.number,
    delay_sequence: PropTypes.number
};

/**
 *
 * @type {{}}
 */
GamesMemory.defaultProps = {
    current_name: null,
    data_frames: [],
    parent_id: null,
    quiz_id: null,
    delay_sequence: 1000
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(GamesMemory, {className: 'GamesMemory'});
